<template>
  <div class="active-schools">
    <h1 class="text-center mb-10">پنل مدیریت نمایندگی</h1>
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <NavigationComponent />
      </v-col>
      <v-col cols="12" md="9" class="px-2">
        <h3 class="mb-5">لیست مدارس فعال سامانه</h3>
        <v-data-table :headers="headers" :items="schools" :items-per-page="10">
          <template v-slot:[`item.requestDate`]="{ item }">
            <persian-date :date="item.requestDate" />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import NavigationComponent from "./_Navigation.vue";

export default {
  name: "actived-school-component",
  components: {
    NavigationComponent
  },
  data: () => {
    return {
      schools: [],
      headers: [
        { text: "نام مدرسه", value: "title", align: "center" },
        { text: "نام مدیر", value: "moderator", align: "center" },
        { text: "نام رابط", value: "coordinator", align: "center" },
        { text: "شماره تماس", value: "mobilenumber", align: "center" },
        { text: "استان", value: "state", align: "center" },
        { text: "تاریخ درخواست", value: "requestDate", align: "center" }
      ]
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$api.get("/agents/schools").then((res) => {
        this.schools = res.data.schools;
      });
    }
  }
};
</script>
